export default __webpack_public_path__ + "static/media/377.caab5e61.png";